var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.679688 19.1525C0.679688 20.9942 2.08802 22.4025 3.92969 22.4025H19.0964C20.938 22.4025 22.3464 20.9942 22.3464 19.1525V10.4858H0.679688V19.1525ZM19.0964 2.90251H16.9297V1.81917C16.9297 1.16917 16.4964 0.73584 15.8464 0.73584C15.1964 0.73584 14.763 1.16917 14.763 1.81917V2.90251H8.26302V1.81917C8.26302 1.16917 7.82969 0.73584 7.17969 0.73584C6.52969 0.73584 6.09635 1.16917 6.09635 1.81917V2.90251H3.92969C2.08802 2.90251 0.679688 4.31084 0.679688 6.15251V8.31917H22.3464V6.15251C22.3464 4.31084 20.938 2.90251 19.0964 2.90251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.12ed878f965391fef5dd8e6ddace4eed.svg";
export { ForwardRef as ReactComponent };